__turbopack_context__.v({
  "tableWrapper": "trancheTable-module-scss-module__cmsjlG__tableWrapper",
});
